import {combineReducers, Reducer} from '@reduxjs/toolkit'

import {routerReducer} from '@web/slices/router'

import {State} from '../../interfaces/confirm'
import common from '../../slices/common'
import purchaseConfirmation from '../../slices/purchaseConfirmation'
import reward from '../../slices/reward'

const createRootReducer = (): Reducer<State> =>
    combineReducers({
        common,
        purchaseConfirmation,
        reward,
        router: routerReducer,
    })

export default createRootReducer
